const QRCareCenterInsideTypes = {
	careCenter: 'care-center',
	class: 'class'
}

export default QRCareCenterInsideTypes
